
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/silver-price-calculator",
      function () {
        return require("private-next-pages/silver-price-calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/silver-price-calculator"])
      });
    }
  